module.exports = __webpack_public_path__ + "static/media/animals.33d5b483.jpg";